import { Component, type ReactNode } from 'react';
import posthog from 'posthog-js';
import { isChunkLoadError } from '~/containers/PostHogConsentManager';

type Props = {
  fallback: ReactNode;
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    if (isChunkLoadError(error.message)) {
      window.location.reload();
      return;
    }

    try {
      posthog.captureException?.(error);
    } catch {
      // PostHog may not be initialized — silently ignore
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
